// extracted by mini-css-extract-plugin
module.exports = {"title":"Index_title__QAP_z","h1":"Index_h1__LA4wg","h2":"Index_h2__MtYs9","h3":"Index_h3__5vc_x","h4":"Index_h4__WbNee"};